(()=>{if(customElements.get('as-brooklyn-carat-preview'))return;
let rememberedView='original';
class BrooklynPreview extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;
  this.range=this.querySelector('input');this.stage=this.querySelector('.as-brooklyn-carat-stage');
  this.tabs=this.querySelector('.as-brooklyn-carat-tabs');
  this.view=rememberedView;this.controller=new AbortController();const signal=this.controller.signal;
  this.tabs.querySelectorAll('[data-view]').forEach(b=>b.addEventListener('click',()=>{this.view=b.dataset.view;rememberedView=this.view;this.render();},{signal}));
  this.range.addEventListener('input',()=>this.render(),{signal});
  this.range.addEventListener('change',()=>this.applyCarat(),{signal});
  document.addEventListener('change',e=>{if(!this.contains(e.target)&&e.target.closest('variant-picker'))setTimeout(()=>this.sync(),50);},{signal});
  document.addEventListener('variant:update',()=>this.sync(),{signal});
  this.dataset.ready='true';this.sync();
  this.moveTabs();
  this.tabsObserver=new MutationObserver(()=>this.moveTabs());
  const product=this.closest('product-component');
  if(product)this.tabsObserver.observe(product,{childList:true,subtree:true});
 }
 disconnectedCallback(){this.controller?.abort();this.tabsObserver?.disconnect();this.tabs?.remove()}
 moveTabs(){
  const heading=this.closest('product-component')?.querySelector('.product-details h1');
  if(!heading||!this.tabs)return;
  const target=heading.closest('.text-block')||heading;
  if(target.previousElementSibling!==this.tabs)target.before(this.tabs);
 }
 picker(){return this.closest('product-component')?.querySelector('variant-picker')||document.querySelector('.product-details variant-picker')}
 stoneSelect(){return [...(this.picker()?.querySelectorAll('select')||[])].find(s=>[...s.options].some(o=>/\d+(?:\.\d+)?\s*CT.*Round/i.test(o.textContent)))}
 carat(t){return Number(t?.match(/(\d+(?:\.\d+)?)\s*CT/i)?.[1])}
 sync(){const s=this.stoneSelect();const v=s?.selectedOptions[0];const n=this.carat(v?.textContent);
 if(n>=2&&n<=10)this.range.value=String(n);this.render()}
 diameter(n){return 8+6*(Math.cbrt(n)-Math.cbrt(2))/(Math.cbrt(10)-Math.cbrt(2))}
 render(){
  const n=Number(this.range.value),diameter=this.diameter(n);this.dataset.view=this.view;
  this.querySelector('output').textContent=n+' ct · '+diameter.toFixed(1)+' mm';this.range.setAttribute('aria-valuetext',n+' carats, approximately '+diameter.toFixed(1)+' millimeters diameter');
  this.tabs.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===this.view)));
  if(this.view!=='original'){
   this.stage.style.setProperty('--stone-width',(12.8*diameter/8)+'%');
   this.stage.setAttribute('aria-label',n+' carat round diamond on-hand preview, approximately '+diameter.toFixed(1)+' millimeters diameter');
  }
 }
 applyCarat(){
  const s=this.stoneSelect(),n=Number(this.range.value),status=this.querySelector('.as-brooklyn-carat-status');
  if(!s){status.textContent='Preview only. Choose your center size in the product options.';return}
  const current=s.selectedOptions[0]?.textContent||'',grade=/E\s*VVS2/i.test(current)?'E VVS2':'F VS1';
  const option=[...s.options].find(o=>this.carat(o.textContent)===n&&o.textContent.includes(grade)&&!o.disabled);
  if(!option){status.textContent='Preview only. This selection is unavailable in the current options.';return}
  status.textContent='';s.value=option.value;s.dispatchEvent(new Event('change',{bubbles:true}));
 }
}
customElements.define('as-brooklyn-carat-preview',BrooklynPreview);
})();